import React from 'react';
import PropTypes from 'prop-types';

import { formatPrice } from 'common/formatters';

import './UpSelfOnboarding.less';

const UpSelfOnboardingReferrerHeader = ({ referrerName, referrerDefaultAmount }) => {
  if (!referrerName || !referrerDefaultAmount) {
    return null;
  }
  return (
    <div styleName="referrerHeader">
      <div styleName="referrerHeaderIcon" />
      <div styleName="referrerHeaderTitle">
        {referrerName} referred you to get&nbsp;
        <span styleName="referrerHeaderTitleBold">{formatPrice(referrerDefaultAmount)}</span>.
      </div>
    </div>
  );
};

UpSelfOnboardingReferrerHeader.propTypes = {
  referrerName: PropTypes.string,
};

UpSelfOnboardingReferrerHeader.displayName = 'UpSelfOnboardingReferrerHeader';

export default UpSelfOnboardingReferrerHeader;
